import Vue from 'vue'
import Vuex from 'vuex'

import mordenItem from "./assets/json/items/MordenkainenItemList.json";
import fireArms from "./assets/json/items/FireArms.json"
import nyborsTome from "./assets/json/items/NyborsTome.json"
import elminstersGuide from "./assets/json/items/ElminstersGuide.json"
import dmGuide from "./assets/json/items/DmGuide.json"

function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

const officialData = function () {
    let itemData = getUniqueListBy([...dmGuide], 'Name');
    itemData = itemData.map(function (el) {
        el._cellClasses = {
            Name: "correct-text-styling",
            Type: "correct-text-styling"
        };
        el.Name = el.Name.toLowerCase();
        return el;
    });

    return itemData;
}

const homebrewData = function () {
    let itemData = getUniqueListBy([...mordenItem, ...nyborsTome, ...fireArms, ...elminstersGuide], 'Name');

    itemData = itemData.map(function (el) {
        el._cellClasses = {
            Name: "correct-text-styling",
            Type: "correct-text-styling"
        };
        el.Name = el.Name.toLowerCase();
        return el;
    });

    return itemData;
}

Vue.use(Vuex)

const state = {
    sidebarShow: 'responsive',
    sidebarMinimize: false,
    userData: null,
    loggedIn: false,
    officialItemData: officialData(),
    homebrewItemData: homebrewData(),
    itemData: []
}

const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
    changeLoginState(state, currentStatus) {
        state.loggedIn = currentStatus;
    }
}

const getters = {
    getCurrentItemList: state => {
        return state.itemData;
    },
    getUniqueListBy: (arr, key) => {
        return [...new Map(arr.map(item => [item[key], item])).values()]
    }
}

export default new Vuex.Store({
    state,
    mutations,
    getters
})